export const formatCurrency = (
  value: number | undefined,
  showDecimals: boolean = true,
) => {
  return new Intl.NumberFormat("es-AR", {
    style: "decimal",
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(value ?? 0); // En caso de que value sea undefined, se usará 0.
};
